goog.module('yext.approvals.tooltip');

/**
 * Shows hover tool tips on rows in entity edit
 */
class EntityToolTip {
  constructor() {
  }

  init() {
    this.buildToolTips();
  }

  buildToolTips() {
    var tooltipOptions = {
      event: 'hover',
      location: 'right',
      hoverDelay: 300,
      fadeDuration: 300,
      propagate: true,
    };

    $('.js-locked-approval-field').contextualHelp($.extend({}, tooltipOptions, {
      contentElement: '.js-locked-approval-tooltip',
    }));
  }
}

exports = {
  EntityToolTip,
};
